/* Blog listing filter + search (sections/la-blog.liquid).

   Filters every post in the browser from templates/blog.filter-index.liquid:
   any chosen tag within a group, every group across groups — the same rule as
   the recipe hub. Shopify's tagged routes can only do one tag, or several ANDed
   together, which is wrong inside a group ("rum" + "gin" would mean posts
   containing both).

   The index (~75KB for 170 posts) is only fetched once a visitor reaches for the
   filter or the search box, or lands on a view that needs it (a tagged URL or a
   ?tags= / ?q= link) — not on every blog visit.

   Progressive: chips are real links to the tagged route and the search box is
   a real GET form. If the index can't be had, a chip click goes to its link
   and a search submits to the search page, so nothing is ever a dead end. */
(function () {
  'use strict';

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Excerpts come through strip_html with their entities intact ("&amp;"), so
  // they are decoded once here and escaped once on the way back into markup.
  var decoder = document.createElement('textarea');
  function decode(str) {
    decoder.innerHTML = String(str == null ? '' : str);
    return decoder.value;
  }

  function sized(url, w) {
    var base = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function isModified(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1;
  }

  function init(root) {
    if (root.dataset.labInit) return;
    root.dataset.labInit = '1';

    var d = root.dataset;
    var pageSize = parseInt(d.pageSize, 10) || 12;
    var titleEl = root.querySelector('[data-lab-title]');
    var sideEl = root.querySelector('.lab__side');
    var form = root.querySelector('[data-lab-search]');
    var input = root.querySelector('[data-lab-input]');
    var clearBtn = root.querySelector('[data-lab-clear]');
    var toggleBtn = root.querySelector('[data-lab-toggle]');
    var panelEl = root.querySelector('[data-lab-filters]');
    var activeEl = root.querySelector('[data-lab-active]');
    var badgeEl = root.querySelector('[data-lab-badge]');
    var statusEl = root.querySelector('[data-lab-status]');
    var resultsEl = root.querySelector('[data-lab-results]');
    var emptyEl = root.querySelector('[data-lab-empty]');
    var moreBtn = root.querySelector('[data-lab-more]');
    var defaultEl = root.querySelector('[data-lab-default]');
    var currentTags = (d.currentTags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var params = new URLSearchParams(window.location.search);
    // On a tagged URL the server-rendered grid is that tag's posts, not the
    // whole blog, so an empty filter can't fall back to it there.
    var defaultIsWholeBlog = currentTags.length === 0;
    var onTaggedRoute = !defaultIsWholeBlog;

    /* Pin the bar flush under the header's real bottom edge — the static
       --header-height token drifts from the rendered header. Same as the hub. */
    (function trackHeaderBottom() {
      var headerEl = document.querySelector('.header-section, header-component, header');
      if (!headerEl) return;
      var last = null, queued = false;
      function measure() {
        queued = false;
        var b = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
        if (b !== last) { last = b; root.style.setProperty('--lab-sticky-top', b + 'px'); }
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(measure); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      measure();
    })();

    // --- accordions + mobile toggle (no index needed) -------------------------
    if (toggleBtn && panelEl) {
      toggleBtn.addEventListener('click', function () {
        var open = panelEl.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', String(open));
      });
      panelEl.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panelEl.classList.contains('is-open')) {
          panelEl.classList.remove('is-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.focus();
        }
      });
    }
    root.querySelectorAll('[data-lab-group-btn]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        btn.setAttribute('aria-expanded', String(!panel.hidden));
      });
    });

    // --- groups, read from the server-rendered chips ---------------------------
    var groups = [];
    var chipByTag = {};
    var touched = false;
    root.querySelectorAll('[data-lab-group]').forEach(function (groupEl) {
      var g = { el: groupEl, active: new Set(), chips: [] };
      groupEl.querySelectorAll('[data-tag]').forEach(function (chip) {
        var tag = chip.getAttribute('data-tag');
        g.chips.push(chip);
        (chipByTag[tag] = chipByTag[tag] || []).push({ g: g, chip: chip });
        chip.setAttribute('role', 'button');
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-current') === 'page' ? 'true' : 'false');
        chip.removeAttribute('aria-current');
        chip.addEventListener('click', function (e) {
          if (isModified(e)) return; // let "open in new tab" reach the real link
          e.preventDefault();
          load().then(function () {
            setFacet(g, tag, !g.active.has(tag));
            touched = true;
            apply();
          }, function () { window.location.href = chip.href; });
        });
        // role=button promises Space as well as Enter
        chip.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); chip.click(); }
        });
      });
      groups.push(g);
    });

    function setFacet(g, tag, on) {
      g.active[on ? 'add' : 'delete'](tag);
      g.chips.forEach(function (c) {
        if (c.getAttribute('data-tag') === tag) c.setAttribute('aria-pressed', String(on));
      });
    }

    function labelOf(tag) {
      var hit = chipByTag[tag];
      return hit ? hit[0].chip.textContent.trim() : tag.replace(/-/g, ' ');
    }

    // --- index -------------------------------------------------------------------
    var posts = null;
    var loading = null;
    function load() {
      if (loading) return loading;
      loading = fetch(d.indexUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('filter index HTTP ' + r.status);
          return r.json();
        })
        .then(function (index) {
          var list = index.posts || [];
          // The index is one page of at most 250 posts. Past that, filtering it
          // would quietly miss posts, so stand down and let the links work.
          if (typeof index.count === 'number' && index.count > list.length) {
            throw new Error('index holds ' + list.length + ' of ' + index.count + ' posts');
          }
          list.forEach(function (p) {
            p.g = (p.g || []).map(function (t) { return String(t).toLowerCase(); });
            p.t = decode(p.t);
            p.e = decode(p.e);
            p._s = (p.t + ' ' + p.e + ' ' + p.g.join(' ') + ' ' + (p.l || '')).toLowerCase();
          });
          posts = list;
          // A tag no post carries would open an empty result; hide it rather
          // than trust that the typed list and the posts agree.
          groups.forEach(function (g) {
            var any = false;
            g.chips.forEach(function (chip) {
              var tag = chip.getAttribute('data-tag');
              var used = posts.some(function (p) { return p.g.indexOf(tag) > -1; });
              chip.parentElement.hidden = !used;
              if (used) any = true; else g.active.delete(tag);
            });
            g.el.hidden = !any;
          });
        });
      loading.catch(function (err) { console.warn('[la-blog] in-page filter unavailable; links navigate instead:', err.message); });
      return loading;
    }
    // Warm the index the moment a visitor reaches for the filter or search.
    if (sideEl) {
      ['pointerdown', 'focusin', 'mouseover'].forEach(function (type) {
        sideEl.addEventListener(type, function () { load(); }, { once: true, passive: true });
      });
    }

    // --- pager -------------------------------------------------------------------
    var matched = [], shown = 0;
    function card(p) {
      var media = p.i
        ? '<a class="lab__media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
          '<img src="' + esc(sized(p.i, 600)) + '" srcset="' +
          [300, 450, 600, 800].map(function (w) { return esc(sized(p.i, w)) + ' ' + w + 'w'; }).join(', ') +
          '" sizes="(max-width: 599px) 92vw, (max-width: 1199px) 40vw, 28vw" alt="" loading="lazy"></a>'
        : '';
      return '<li class="lab__card la-card">' + media +
        (p.l ? '<p class="lab__meta">' + esc(p.l) + '</p>' : '') +
        '<div class="lab__card-body">' +
        '<h2 class="lab__card-title"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h2>' +
        (p.e ? '<p class="lab__excerpt">' + esc(p.e) + '</p>' : '') +
        '<p class="lab__foot"><time datetime="' + esc(p.dt) + '">' + esc(p.d) + '</time>' +
        '&nbsp;·&nbsp;' + esc(p.m) + ' ' + esc(d.readTime || '') + '</p>' +
        '</div></li>';
    }
    function renderNext() {
      resultsEl.insertAdjacentHTML('beforeend', matched.slice(shown, shown + pageSize).map(card).join(''));
      shown = Math.min(shown + pageSize, matched.length);
      moreBtn.hidden = shown >= matched.length;
    }
    moreBtn.addEventListener('click', function () {
      // :focus-visible is the browser's own read of "driving by keyboard" — only
      // then hand focus to the first new card (the button may have just gone).
      var kbd = false;
      try { kbd = moreBtn.matches(':focus-visible'); } catch (e) { kbd = false; }
      var first = shown;
      renderNext();
      var link = kbd && resultsEl.children[first] && resultsEl.children[first].querySelector('.lab__card-title a');
      if (link) link.focus();
    });

    // --- active chips ------------------------------------------------------------
    function renderActive() {
      if (!activeEl) return 0;
      activeEl.textContent = '';
      var total = 0;
      groups.forEach(function (g) {
        g.active.forEach(function (tag) {
          total++;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lab__active-chip';
          b.textContent = labelOf(tag);
          b.setAttribute('aria-label', (d.remove || 'Remove filter') + ': ' + labelOf(tag));
          b.addEventListener('click', function () { setFacet(g, tag, false); touched = true; apply(); });
          activeEl.appendChild(b);
        });
      });
      if (total) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'lab__clear';
        c.textContent = d.clear || 'Clear all';
        c.addEventListener('click', function () {
          groups.forEach(function (g) { Array.from(g.active).forEach(function (t) { setFacet(g, t, false); }); });
          touched = true;
          apply();
        });
        activeEl.appendChild(c);
      }
      activeEl.hidden = !total;
      if (badgeEl) badgeEl.textContent = total ? ' (' + total + ')' : '';
      return total;
    }

    // --- apply -------------------------------------------------------------------
    function apply() {
      if (!posts) return;
      var q = input ? input.value.trim().toLowerCase() : '';
      var words = q ? q.split(/\s+/) : [];
      var facets = renderActive();

      if (touched) syncUrl(q);

      if (!facets && !q && defaultIsWholeBlog) {
        resultsEl.hidden = true;
        resultsEl.textContent = '';
        emptyEl.hidden = true;
        moreBtn.hidden = true;
        defaultEl.hidden = false;
        // Say so when filters are cleared, or screen-reader users hear nothing.
        statusEl.textContent = touched ? (d.all || '') : '';
        return;
      }

      matched = posts.filter(function (p) {
        var ok = groups.every(function (g) {
          if (!g.active.size) return true;
          return p.g.some(function (t) { return g.active.has(t); });
        });
        return ok && words.every(function (w) { return p._s.indexOf(w) > -1; });
      });

      defaultEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.textContent = '';
      shown = 0;
      var n = matched.length;
      statusEl.textContent = n === 1 ? (d.countOne || '1 post') : (d.count || '[count] posts').replace('[count]', n);
      emptyEl.textContent = d.none || '';
      emptyEl.hidden = n !== 0;
      renderNext();
    }

    /* Keep the address shareable. A tagged URL is left behind on the first
       change: its heading names one tag, and the view no longer matches it. */
    function syncUrl(q) {
      var tags = [];
      groups.forEach(function (g) { g.active.forEach(function (t) { tags.push(t); }); });
      var p = new URLSearchParams();
      if (tags.length) p.set('tags', tags.join(','));
      if (q) p.set('q', q);
      var qs = p.toString();
      try { history.replaceState(null, '', d.blogUrl + (qs ? '?' + qs : '')); } catch (e) { /* sandboxed */ }
      if (onTaggedRoute) {
        onTaggedRoute = false;
        if (titleEl && titleEl.dataset.default) {
          titleEl.textContent = titleEl.dataset.default;
          titleEl.classList.remove('lab__title--tag');
        }
      }
    }

    // --- search ------------------------------------------------------------------
    if (form && input) {
      var timer = null;
      input.addEventListener('input', function () {
        if (input.value.trim()) form.setAttribute('data-has-query', ''); else form.removeAttribute('data-has-query');
        clearTimeout(timer);
        timer = setTimeout(function () { load().then(function () { touched = true; apply(); }, function () {}); }, 150);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(timer);
        load().then(function () { touched = true; apply(); }, function () { form.submit(); });
      });
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          form.removeAttribute('data-has-query');
          input.focus();
          if (posts) { touched = true; apply(); }
        });
      }
    }

    // --- initial state -----------------------------------------------------------
    // The tag this URL names, plus any ?tags= / ?q= deep link. Only these views
    // need the index up front; the plain blog waits for intent.
    var wanted = currentTags.concat((params.get('tags') || '').split(','))
      .map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var q0 = params.get('q') || '';
    var known = wanted.filter(function (t) { return chipByTag[t]; });
    if (input && q0) { input.value = q0; form.setAttribute('data-has-query', ''); }
    if (known.length || q0) {
      load().then(function () {
        known.forEach(function (t) {
          chipByTag[t].forEach(function (h) { if (!h.chip.parentElement.hidden) setFacet(h.g, t, true); });
        });
        apply();
      }, function () {});
    }
  }

  document.querySelectorAll('[data-lab]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lab]').forEach(init);
  });
})();
